import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import Layout from './components/Layout';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookieConsentBanner from './components/CookieConsentBanner'; // ✅ Add this
import { tools } from './toolData';

const loadComponent = (name) => {
  const LazyComponent = React.lazy(() => import(`./components/${name}.jsx`));
  return (
    <React.Suspense fallback={<div className="text-center text-white">Loading...</div>}>
      <LazyComponent />
    </React.Suspense>
  );
};

export default function App() {
  const dynamicRoutes = tools.map(tool => (
    <Route
      key={tool.id}
      path={`/${tool.id}`}
      element={
        <Layout>
          {loadComponent(tool.component)}
        </Layout>
      }
    />
  ));

  return (
    <Router>
      <Navbar />
      
      {/* ✅ Cookie banner is outside Routes so it always displays */}
      <CookieConsentBanner />

      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/category/:category" element={<Layout><CategoryPage /></Layout>} />
        {dynamicRoutes}
      </Routes>
    </Router>
  );
}
